// extracted by mini-css-extract-plugin
export default {"contentBox":"ContentBox-module--contentBox--6mS9l","size__small":"ContentBox-module--size__small--TIhVH","size__normal":"ContentBox-module--size__normal--NeudR"};